module.exports = __webpack_public_path__ + "img/third_zhCn.7a0aaf7d.png";